/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

import Section from 'bundles/front-page/components/Section';
import OverflowCarousel from 'bundles/front-page/components/overflow-carousel/OverflowCarousel';
import MerchandisingBucket from 'bundles/front-page/redesign-modules/merchandising-buckets/MerchandisingBucket';
import getMerchandisingBuckets from 'bundles/front-page/redesign-modules/merchandising-buckets/data/getMerchandisingBuckets';

const style = {
  bucketsGrid: css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    gap: var(--cds-spacing-200);
    width: 100%;

    ${breakpoints.down('xs')} {
      /* 600 / 3 = 200 */
      grid-template-columns: repeat(3, minmax(200px, 1fr));
      width: auto;
    }
  `,
};

const MerchandisingBucketsModuleRenderer = () => {
  const buckets = getMerchandisingBuckets();

  return (
    <Section>
      <OverflowCarousel css={style.bucketsGrid} shouldAllowSpaceForHoverItems>
        {buckets.map((bucket, index) => {
          return (
            <MerchandisingBucket
              key={bucket.title}
              index={index}
              title={bucket.title}
              linkTo={bucket.linkTo}
              image={bucket.image}
            />
          );
        })}
      </OverflowCarousel>
    </Section>
  );
};

export default MerchandisingBucketsModuleRenderer;
